import { Injectable } from '@angular/core';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import customParseFormat from 'dayjs/plugin/customParseFormat';

@Injectable({
  providedIn: 'root',
})
export class DateTimeUtilService {
  displayFormat = {
    year: 'y',
    month: 'MMM y',
    day: 'MMM d, y',
    second: 'MMM d, y; h:mm a',
  };

  onOrBefore(currentDate: string | Date, targetDate: string): boolean {
    dayjs.extend(isSameOrBefore);
    return dayjs(currentDate).isSameOrBefore(
      dayjs(targetDate).endOf(this.getUnit(targetDate))
    );
  }

  getUnit(date: string): dayjs.OpUnitType {
    dayjs.extend(customParseFormat);
    let retVal;
    if (dayjs(date, 'YYYY', true).isValid()) {
      retVal = 'year';
    }
    if (dayjs(date, 'YYYY-MM', true).isValid()) {
      retVal = 'month';
    }
    if (dayjs(date, 'YYYY-MM-DD', true).isValid()) {
      retVal = 'day';
    }
    if (dayjs(date, 'YYYY-MM-DDTHH:mm:ss').isValid()) {
      retVal = 'second';
    }
    return retVal;
  }

  getDisplayFormat(date: string): string {
    return this.displayFormat[this.getUnit(date)];
  }

  getTimeZone(date: Date): string {
    const timezoneOffset = date.getTimezoneOffset();
    const offset = Math.abs(timezoneOffset);
    const offsetOperator = timezoneOffset < 0 ? '+' : '-';
    const offsetHours = Math.floor(offset / 60)
      .toString()
      .padStart(2, '0');
    const offsetMinutes = Math.floor(offset % 60)
      .toString()
      .padStart(2, '0');

    return `${offsetOperator}${offsetHours}:${offsetMinutes}`;
  }
}
